export default __webpack_public_path__ + "static/media/b1.e5796060.jpg";